.signet-chip {
  display: inline-flex;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  height: 10px;
  padding: 8px 10px;
  border-radius: 17px;
  font-size: 10px;
  line-height: 19.5px;
  font-family: Lato, Helvetica, Arial, sans-serif;
  font-weight: 500;
  margin-right: 5px;
}

.signet-chip.filled {
  color: var(--pure-white);
  background: var(--primary-main);
}

.signet-chip.outlined {
  color: var(--text-primary);
  background: transparent;
  border: 1px solid var(--primary-main) !important;
}

.signet-chip-extra-pd-lt {
  padding-left: 40px;
}

.signet-chip-label {
  min-width: 20px;
}

.signet-chip-image {
  position: absolute;
  top: 0;
  left: -1px;
  height: 35px;
  width: 35px;
  margin-right: 10px;

  img {
    height: 100%;
    width: 100%;
    border-radius: 50%;
  }
}

.signet-chip-close {
  width: 15px;
  margin-left: 5px;
  cursor: pointer;
  position: relative;
  margin-top: 10px !important;
  transform: rotate(-45deg);
  color: var(--primary-main);
  user-select: none;
}
